export default "__VITE_ASSET__DCL4j81e__"